import React from 'react';
import Calendar from '../../../Components/Calendar/Calendar';
import { FIELD } from '../../../Library/Variables';

const FieldCalendar = () => {
  return <Calendar type={FIELD} />;
};

export default FieldCalendar;
